import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const SlideUpHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px 8px;
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.secondaryDark};
  padding: 0;

  & > svg {
    width: 16px;
    height: 16px;
    fill: ${COLORS.secondaryDark};
  }
`
